import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engine-prep-page',
  templateUrl: './engine-prep-page.component.html',
  styleUrls: ['./engine-prep-page.component.scss']
})
export class EnginePrepPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
